export default {
  MAP_READY_EVENT: 'MAP_READY_EVENT'
}



// WEBPACK FOOTER //
// ./src/lib/utils/constant.js